/** How an admin email will look: the same layout as the sent email (washi page, white card, vermilion eyebrow). */
export function EmailPreview({ subject, body, to }: { subject: string; body: string; to?: string }) {
  const paragraphs = body.trim().split(/\n{2,}/).filter(Boolean);
  return (
    <div className="rounded-sm bg-paper p-4">
      {to && <p className="mb-2 text-xs text-ink-500">To {to} · {subject || 'No subject'}</p>}
      <div className="mx-auto max-w-[560px] border border-stone-200 bg-white px-6 py-7 text-[15px] leading-relaxed text-ink-900">
        <p className="mb-3 text-xs font-bold tracking-[3px] text-brand-600">EGKA MEMBERS</p>
        <p className="mb-4 text-2xl font-bold leading-tight">{subject || 'Subject'}</p>
        {paragraphs.length ? paragraphs.map((p, i) => <p key={i} className="mb-3 whitespace-pre-line">{p}</p>) : <p className="text-ink-400">Your message appears here.</p>}
        <p className="mt-6 border-t border-stone-200 pt-3 text-xs text-ink-500">English Goju-Ryu Karate-do Association. Questions? Just reply to this email.</p>
      </div>
    </div>
  );
}
